'use client';
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
    apiKey: "AIzaSyDHwQMaNfq7Zb2VH7uKoKQK8NhbqsBn-8c",
    authDomain: "truklex-app.firebaseapp.com",
    projectId: "truklex-app",
    storageBucket: "truklex-app.appspot.com",
    messagingSenderId: "76582737029",
    appId: "1:76582737029:web:3c497eeeb9dd75031d85ec",
    measurementId: "G-Z40WWV2YNW"
};

const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);

export const requestForToken = () => {
    return getToken(messaging, { vapidKey: 'BLlK-DVlY8HHevNpCqNZhJ7AQyHtF8MBocCFGr42zR12Ec2ZSaY4TTPK7Nl5cvEdv-sctRq0RpoxV0uwoViK-cY' })
        .then((currentToken) => {
            if (currentToken) {
                console.log('current token for client: ', currentToken);
                return currentToken;
                // Send the token to your server and update the UI
            } else {
                console.log('No registration token available. Request permission to generate one.');
            }
        })
        .catch((err) => {
            console.log('An error occurred while retrieving token. ', err);
        });
};

export const onMessageListener = () =>
    new Promise((resolve) => {
        onMessage(messaging, (payload) => {
            resolve(payload);
        });
    });